//

import { useEffect } from "react";
import { useSelector } from "react-redux";
import ActionColumnInProgress from "../../../components/JobModuleComponent/InProgressTabComponent/ActionColumnInProgress";
import AutoRefreshInProgressCheckbox from "../../../components/JobModuleComponent/InProgressTabComponent/AutoRefreshInProgressCheckbox";
import DeleteJobModal from "../../../components/SharedComponent/ModalComponent/DeleteJobModal";
import DocumentInfoModal from "../../../components/SharedComponent/ModalComponent/DocumentInfoModal";
import DownloadModal from "../../../components/SharedComponent/ModalComponent/DownloadModal";
import UnlockModal from "../../../components/SharedComponent/ModalComponent/UnlockModal";
import TableColumn from "../../../components/SharedComponent/TableColumnComponent/TableColumn";
import TableComponent from "../../../components/SharedComponent/TableComponent/TableComponent";
import { stopArchivedAutoRefresh } from "../../../redux/JobModule/ArchivedPage/ArchivedAction";
import { stopNewCompletedAutoRefresh } from "../../../redux/JobModule/CompletedPage/NewCompletedAction";
import { closeDeleteModal, closeDocumentInfoModal, closeUnlockModal, fetchInprogressAudios, fetchPaginateInprogressAudios, openDeleteModal, openDocumentInfoModal, openUnlockModal, resetInProgressTable, stopInProgressAutoRefresh, switchInProgressAutoFresh, updateInProgressRequestBody } from "../../../redux/JobModule/InProgressPage/InProgressAction";
import { RootState } from "../../../redux/store";
import { closeDownloadModal, openDownloadModal } from "../../../redux/Transcribe/TranscribeAction";
import { useAppDispatch } from "../../../redux/useAppDispatch";

function NewTabContent(props: any) {
  const dispatch = useAppDispatch();

  //Modal State Getting
  const documentInfoModalState = useSelector((state: RootState) => state.InProgressAudiosState.documentInfoModalState);
  const deleteModalState = useSelector((state: RootState) => state.InProgressAudiosState.deleteModalState);
  const unlockModalState = useSelector((state: RootState) => state.InProgressAudiosState.unlockModalState);
  const downloadModalState = useSelector((state: RootState) => state.TranscribeState.downloadModalState);

  const inProgressPageState = useSelector((state: RootState) => state.InProgressAudiosState);
  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }

      return false;
    };

    const newSortingRequestBody = {
      ...inProgressPageState.currentRequestBody,
      SortColumn: sorter.field,
      IsAsc: isAscend(sorter.order),
    };

    dispatch(resetInProgressTable());
    dispatch(updateInProgressRequestBody(newSortingRequestBody));
    dispatch(fetchInprogressAudios({}));
  };

  //Each rendering
  useEffect(() => {
    dispatch(fetchInprogressAudios({}));
    dispatch(switchInProgressAutoFresh({ autoRefresh: true }));

    return () => {
      dispatch(stopArchivedAutoRefresh());
      dispatch(stopNewCompletedAutoRefresh());
      dispatch(stopInProgressAutoRefresh());
      dispatch(resetInProgressTable());
    };
  }, []);

  const InProgressSortTable = TableColumn.map((column) => {
    return {
      ...column,
      sortOrder: inProgressPageState.currentRequestBody.SortColumn === column.key ? (inProgressPageState.currentRequestBody.IsAsc ? "ascend" : "descend") : null,
    };
  });

  const InProgressTableColumn = [
    ...InProgressSortTable,
    {
      title: "Actions",
      key: "", //Need to add the key and dataIndex
      dataIndex: "",

      render: (value: any, record: any) => {
        return <ActionColumnInProgress record={record} />;
      },
      width: 90,
    },
  ];

  return (
    <div className="body-container gap-3">
      <AutoRefreshInProgressCheckbox />
      <TableComponent
        columns={InProgressTableColumn}
        dataSource={inProgressPageState.data}
        pagination={inProgressPageState.pagination}
        handleTableSorting={handleTableSorting}
        fetchPaginatedData={() => fetchPaginateInprogressAudios({})}
        loading={inProgressPageState.loading}
        tableKey={"InProgressTab"}
      />
      <DocumentInfoModal
        openState={documentInfoModalState}
        open={() => dispatch(openDocumentInfoModal())}
        close={() => dispatch(closeDocumentInfoModal())}
      />

      <DeleteJobModal
        openState={deleteModalState}
        open={() => dispatch(openDeleteModal())}
        close={() => dispatch(closeDeleteModal())}
      />

      <UnlockModal
        openState={unlockModalState}
        open={() => dispatch(openUnlockModal())}
        close={() => dispatch(closeUnlockModal())}
      />

      <DownloadModal
        openState={downloadModalState}
        open={() => dispatch(openDownloadModal())}
        close={() => dispatch(closeDownloadModal())}
      />
    </div>
  );
}

export default NewTabContent;
